import React from 'react';
import { authRoles } from 'app/auth';

/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
const CandidateSignupConfig = {
	settings: {
		layout: {
			config: {
				navbar: { display: false },
				toolbar: { display: false },
				footer: { display: false },
				leftSidePanel: { display: false },
				rightSidePanel: { display: false }
			}
		}
	},
	auth: authRoles.onlyGuest,
	routes: [
		{
			path: '/candidate/signup',
			component: React.lazy(() => import('./signup/CandidateSignup'))
		}
	]
};

export default CandidateSignupConfig;
/* Code end. Harsha using AI Agent. July 9, 2026 */
